// extracted by mini-css-extract-plugin
export default {"action":"YWHEpeLeL8yEgjtLL0yt"};